import { clearMobileAuthToken, setMobileAuthToken } from 'MobileAuthToken';
import angularModule from './authentication_module';

angularModule.factory('AuthClient', [
    '$injector',
    $injector => {
        const $http = $injector.get('$http');
        const $rootScope = $injector.get('$rootScope');
        const ErrorLogService = $injector.get('ErrorLogService');

        const AUTH_ROOT = `${window.ENDPOINT_ROOT}/auth`;
        const extractAndSetMobileAuthToken = async response => {
            const token = response.headers('Authorization').split(' ')[1];
            try {
                await setMobileAuthToken(token);
            } catch (error) {
                ErrorLogService.notify('Failed to persist mobile auth token', error);
            }
        };

        return {
            showSelf: () =>
                $http
                    .get(`${AUTH_ROOT}/session.json`)
                    .then(response => {
                        const user = response.data;
                        $rootScope.$broadcast('auth:validation-success', user);
                        return user;
                    })
                    .catch(response => {
                        $rootScope.$broadcast('auth:validation-error', response);
                        throw response;
                    }),
            signIn: params =>
                $http
                    .post(`${AUTH_ROOT}/session.json`, params)
                    .then(async response => {
                        if (window.CORDOVA) await extractAndSetMobileAuthToken(response);

                        const user = response.data;
                        $rootScope.$broadcast('auth:login-success', user);
                        return user;
                    })
                    .catch(response => {
                        $rootScope.$broadcast('auth:login-error', response);
                        throw response;
                    }),
            signOut: () =>
                $http.delete(`${AUTH_ROOT}/session.json`).finally(async () => {
                    if (window.CORDOVA) {
                        window.localStorage.removeItem('auth_headers'); // clear lingering DTA headers
                        window.localStorage.removeItem('auth_token'); // clear lingering pre-Preferences vanilla token
                        try {
                            await clearMobileAuthToken();
                        } catch (error) {
                            ErrorLogService.notify('Failed to clear mobile auth token', error);
                        }
                    }
                }),
            signUp: params =>
                $http.post(`${AUTH_ROOT}/registration.json`, params).then(async response => {
                    if (window.CORDOVA) await extractAndSetMobileAuthToken(response);

                    return response.data;
                }),
            resetPassword: params => {
                if (window.CORDOVA) params.endpoint_root = window.ENDPOINT_ROOT;
                return $http.post(`${AUTH_ROOT}/password.json`, params);
            },
            updatePassword: params => $http.put(`${AUTH_ROOT}/password.json`, params),
            initiateOmniauth: (provider, params) => {
                window.location.href = `${AUTH_ROOT}/${provider}?${new URLSearchParams(params)}`;
                return undefined;
            },
            exchangeNativeOauth: (provider, params) =>
                $http
                    .get(`${window.ENDPOINT_ROOT}/auth/native_oauth/${provider}/exchange.json`, { params })
                    .then(async response => {
                        if (window.CORDOVA) await extractAndSetMobileAuthToken(response);

                        return response.data;
                    }),
            updateAccount: params => $http.put(`${AUTH_ROOT}/registration.json`, params),
            confirmProfileInfo: params => $http.put(`${AUTH_ROOT}/registration/confirm_profile_info.json`, params),
        };
    },
]);
